import { ApplicationTypes, attachAdminComponent } from 'sunlife-domain'

import { memoOnce } from '@salsita-ai/platform-common/utils'
import { createAdminPages } from '@salsita-ai/platform-project-sdk/admin'
import { navigationPanelListComponent } from '@salsita-ai/platform-project-sdk/domain'

const { commonComponents, commonPages } = createAdminPages({
  presets: {
    categoryNavigationState: ApplicationTypes.AdminNavigationState.PresetCategories,
    presetNavigationState: ApplicationTypes.AdminNavigationState.Presets,
  },
})

export const adminComponents = [
  ...commonComponents,
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPanelListComponent, 'main')
    .attach(
      memoOnce(() => {
        return {
          items: commonPages,
        }
      })
    ),
]
